export default () => (
  /**
   * Ícone utilizado para simbolizar transparência da camada.
   */
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7.36988" cy="6.8252" r="6.11377" stroke="#5E6366" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.43237 10.9571C9.67205 10.9237 11.4773 9.09774 11.4773 6.85012C11.4773 4.60251 9.67205 2.77655 7.43237 2.74316V10.9571Z"
      fill="#5E6366"
    />
  </svg>
);
